// export const formatCurrencyInBTD = (amount: number = 0) => {
//   const formattedAmount = amount.toLocaleString('en-BD', {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });

//   return `৳ ${formattedAmount}`;
//   // return new Intl.NumberFormat('bn-BD', {
//   //     style: 'currency',
//   //     currency: 'BDT',
//   // }).format(amount);
// };

export const formatCurrencyInBDT = (amount: number = 0): string => {
    const isNegative = amount < 0;
    const absAmount = Math.abs(amount);
    const parts = absAmount.toFixed(2).split('.');
    let integerPart = parts[0];
    const decimalPart = parts[1];

    // First 3 digits from right
    const lastThree = integerPart.slice(-3);
    let rest = integerPart.slice(0, -3);

    if (rest !== '') {
        // Add commas every two digits in the rest
        rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
        integerPart = rest + ',' + lastThree;
    }

    const formatted = '৳' + integerPart + '.' + decimalPart;
    return isNegative ? `-` + formatted : formatted;
};
